// extracted by mini-css-extract-plugin
export default {"workedWith":"WorkedWith_workedWith__CSyJ5","cards":"WorkedWith_cards__qM6XF"};